import { MouseEvent } from 'react';

import {
  MoreLikeThisCard,
  VehicleInformationCard,
} from 'components/MessageExtensions/Carousel/Card';

import { useAnalytics } from 'hooks/useAnalytics';

import { CardProps } from './types';
import { AnalyticClickedLinkDetailsType } from 'analytics/types';
import { CAROUSEL_TEMPLATE_TYPES } from './constants';
import { CHAT_UI_PREFIX } from 'constants/id';
import { ANALYTICS } from 'analytics/constants';
import {
  Container,
  Image,
  SelectableTile,
  ViewMoreTile,
} from 'components/MessageExtensions/Carousel/Card/styles';
import { open } from 'utils/url';

const Card = ({ vehicleInformation }: CardProps) => {
  const { trackEvent } = useAnalytics();
  if (!Object.values(CAROUSEL_TEMPLATE_TYPES).includes(vehicleInformation.templateType)) {
    // TODO: Add error logging
    console.warn('Unrecognized CAROUSEL_TEMPLATE_TYPE: ', vehicleInformation.templateType);
  }

  const onClick = (e: MouseEvent<HTMLDivElement>) => {
    open(vehicleInformation.action.url);
    const { info } = vehicleInformation;
    const vehicleContentStr = `${info.year} ${info.make} ${info.model} ${info.trim}`;
    trackEvent({
      analyticEvent: ANALYTICS.EVENT.CLICKED_LINK,
      details: {
        analytic_click_id: `${CHAT_UI_PREFIX}-vehicle-information-card-details`,
        content: vehicleContentStr,
        url: vehicleInformation.action.url,
      } as AnalyticClickedLinkDetailsType,
    });
  };

  const cardComponents = {
    [CAROUSEL_TEMPLATE_TYPES.MORE_LIKE_THIS]: (
      <ViewMoreTile>
        <MoreLikeThisCard vehicleInformation={vehicleInformation} />
      </ViewMoreTile>
    ),
    [CAROUSEL_TEMPLATE_TYPES.VEHICLE_DETAILS]: (
      <SelectableTile onClick={onClick} id={`${CHAT_UI_PREFIX}-vehicle-information-tile`}>
        <Container>
          <Image src={vehicleInformation.imageUrl} alt={vehicleInformation.title} />
          <VehicleInformationCard vehicleInformation={vehicleInformation} />
        </Container>
      </SelectableTile>
    ),
  };

  return cardComponents[vehicleInformation.templateType];
};

export default Card;
